/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 * 
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import React from "react";

/**
 * Properties of the AbVSeparator component.
 */

/**
 * The **AbVSeparator** component is a simple vertical separator.
 */
export const AbVSeparator = props => {
  return /*#__PURE__*/React.createElement("div", ReactUtils.componentProps("ab-vseparator", props, ["vertical", "abweb-separator"]));
};
//# sourceMappingURL=AbVSeparator.js.map
